import {
    Box,
    Stack,
    Heading,
    Text,
    Container,
    Alert,
    AlertIcon,
    AlertDescription,
    AlertTitle
} from '@chakra-ui/react'
import { ProtectedPage } from '@/shared/components/ProtectedPage'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { useAuth } from '@/shared/context/AuthContext'
import DashboardChildrenSection from '@/pages/user/parent/_components/DashboardChildrenSection'
import TeacherCheckinStats from '@/components/TeacherCheckinStats'
import PermissionGate from '@/shared/components/PermissionGate'
import NotificationsSection from './_components/NotificationsSection'
import { UserTypes } from '@/shared/types/auth'

export default function DashboardPage() {
    const { user } = useAuth()

    return (
        <ProtectedPage routeConfig={PROTECTED_ROUTES['/user/dashboard']}>
            <Box
                minH={['container.sm', 'container.md']}
                borderRadius={4}
                bg={'white'}
                mx={'auto'}
                py={5}
                px={{ base: 2, md: 17 }}
            >
                <Heading fontSize={{ base: '3xl', sm: '3xl' }} fontWeight={'bold'} p={4}>
                    Dashboard
                </Heading>
                <Stack spacing={4} as={Container} maxW={'full'}>
                    <Text fontSize="xl">
                        Welcome,{' '}
                        {`${user?.firstName} ${user?.lastName}`.toLocaleUpperCase()}
                    </Text>
                </Stack>
                <PermissionGate allowedTypes={[UserTypes.OTHERS]}>
                    <Alert status="info" borderRadius="6" my={4} width="fit-content">
                        <AlertIcon />
                        <Box>
                            <AlertTitle>Oops!</AlertTitle>
                            <AlertDescription>
                                You have no user rights at the moment.
                                <br />
                                Contact your the Children Church team
                            </AlertDescription>
                        </Box>
                    </Alert>
                </PermissionGate>
                <PermissionGate allowedTypes={[UserTypes.IS_PENDING_TEACHER]}>
                    <Alert status="warning" borderRadius="6" my={4} width="fit-content">
                        <AlertIcon />
                        <Box>
                            <AlertTitle>{`Teacher's account under review`}</AlertTitle>
                            <AlertDescription>
                                Your account permissions as a teacher has not been
                                approved.
                                <br />
                                Contact your coordinator for approval
                            </AlertDescription>
                        </Box>
                    </Alert>
                </PermissionGate>
                {/* Renders itself only for admin teachers / global admins. */}
                <NotificationsSection />
                <PermissionGate allowedTypes={[UserTypes.IS_PARENT]}>
                    <DashboardChildrenSection />
                </PermissionGate>
                <PermissionGate
                    allowedTypes={[
                        UserTypes.IS_TEACHER,
                        UserTypes.IS_ADMIN_TEACHER,
                        UserTypes.IS_GLOBAL_ADMIN
                    ]}
                >
                    <TeacherCheckinStats />
                </PermissionGate>
            </Box>
        </ProtectedPage>
    )
}
